<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
@if (isScreenSmall) {
<fuse-vertical-navigation class="dark bg-gray-900 print:hidden" [mode]="'over'" [name]="'mainNavigation'"
    [navigation]="navigation.default" [opened]="false">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <!-- Logo -->
        <div class="flex h-20 items-center px-4 cursor-pointer" routerLink="/">
            <img class="w-24" src="images/logo/logo-text-on-dark.svg" alt="Logo image" />
        </div>
    </ng-container>
    <ng-container fuseVerticalNavigationFooter>
        <div class="mb-2 px-2">
            <span class="text-white font-medium text-sm mb-2 ps-2">&copy;{{currentYear}} {{ productName }}. All rights reserved.</span>
        </div>
    </ng-container>
</fuse-vertical-navigation>
}

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
    <!-- Header -->
    <div
        class="bg-card relative z-49 flex h-8 w-full flex-0 items-center px-0 shadow dark:border-b dark:bg-transparent dark:shadow-none sm:h-20 md:px-2 print:hidden">
        @if (!isScreenSmall) {
        <!-- Logo -->
        <div class="mx-2 flex items-center lg:mr-8">
            <a routerLink="/" class="hidden lg:flex">
                <img class="w-24 dark:hidden" src="images/logo/logo-text.svg" alt="logo" />
                <img class="hidden w-24 dark:flex" src="images/logo/logo-text-on-dark.svg" alt="logo" />
            </a>
            <a routerLink="/" class="flex lg:hidden">
                <img class="w-24" src="images/logo/logo.svg" alt="logo" />
            </a>
        </div>
        <!-- Horizontal navigation -->
        <fuse-horizontal-navigation class="mr-2" [name]="'mainNavigation'"
            [navigation]="navigation.horizontal"></fuse-horizontal-navigation>
        }
        <!-- Navigation toggle button -->
        @if (isScreenSmall) {
        <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon class="icon-size-4" [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>
        }
        <!-- Components -->
        <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
            <!-- <languages></languages> -->
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <!-- <cva-standalone-user></cva-standalone-user> -->
             @if (isScreenSmall && showHelpIcon) {
                <button mat-icon-button [matMenuTriggerFor]="helpMenu">
                    <mat-icon class="icon-size-4" [svgIcon]="'mat_solid:help'"></mat-icon>
                </button>
                <mat-menu #helpMenu="matMenu">
                    <button mat-menu-item (click)="openGuideDocument()">
                        <mat-icon class="icon-size-4" [svgIcon]="'heroicons_solid:document-text'"></mat-icon>
                        <span>Guide Document</span>
                    </button>
                    <button mat-menu-item (click)="openGuideVideo()">
                        <mat-icon class="icon-size-4" [svgIcon]="'mat_solid:video_library'"></mat-icon>
                        <span>Tour Video</span>
                    </button>
                </mat-menu>
            }
        </div>
    </div>

    <!-- Content -->
    <div class="flex w-full flex-auto flex-col">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
        <cva-standalone-subscription-validator></cva-standalone-subscription-validator>
        <router-outlet></router-outlet>
        }
    </div>

    <!-- Footer -->
    <!-- <div
        class="bg-card relative z-49 flex h-8 w-full flex-0 items-center border-t px-4 dark:bg-transparent md:px-6 print:hidden">
        <span class="text-secondary font-medium text-sm">&copy;{{currentYear}} {{ productName }}. All rights reserved.</span>
    </div> -->
</div>